import * as L from 'leaflet';
/**
 * The clip layer's default options.
 */
const LAYER_CLIP_OPTIONS_DEFAULT = {
    // don't clip the clip layer
    noClip: true,
    style(feature) {
        if (feature && feature.properties && feature.properties.style) {
            return feature.properties.style;
        }
    },
};
/**
 * The clip layer.
 */
export class LayerClip extends L.GeoJSON {
    /**
     * @param options - The clip layer options.
     */
    constructor(options) {
        var _a;
        const style = options.style
            ? options.style
            : {
                weight: 2,
                color: '#000',
                opacity: 1,
                fillColor: '#fff',
                fillOpacity: 0.7,
            };
        // outer ring (whole world)
        const coordinates = [
            [
                [90, -180],
                [90, 180],
                [-90, 180],
                [-90, -180],
            ],
        ];
        (_a = options.polygons) === null || _a === void 0 ? void 0 : _a.forEach((polygon) => coordinates.push(polygon));
        const geojson = {
            type: 'Feature',
            properties: { style },
            geometry: {
                type: 'MultiPolygon',
                coordinates: [coordinates],
            },
        };
        super(geojson, Object.assign(Object.assign({}, LAYER_CLIP_OPTIONS_DEFAULT), options));
    }
    /**
     * The hook to execute when the control is added to the map.
     * @param map The Leaflet map the layer is added to.
     * @returns The clip layer instance.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#layer-extension-methods}
     */
    onAdd(map) {
        // increase the padding of the Renderer, when the LayerClip is added to the map to avoid flickering.
        const renderer = this._map.getRenderer(this);
        renderer.options.padding = 2;
        L.GeoJSON.prototype.onAdd.call(this, map);
        return this;
    }
}
//# sourceMappingURL=LayerClip.js.map